export default __webpack_public_path__ + "img/pin_icons/heat_exchanger_b.png";